import { Component } from '@angular/core';
import { InformacionService } from "../../services/informacion.service";
import { TranslateService } from 'ng2-translate';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
let $: any;

@Component({
  selector: 'app-biografia',
  templateUrl: './biografia.component.html'
})
export class BiografiaComponent {
  seccion: any;
  closeResult: string;
  constructor ( public _is:InformacionService, private translate:TranslateService, public modalService: NgbModal ){}

  abrirModal(seccion: any, modal) {
    this.seccion = seccion;
    this.modalService.open(modal);
  }

  open(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/components/biografia/biografia.component.ts